/* unplugin-vue-components disabled */import script from "./DepartDoctor.vue?vue&type=script&lang=ts&setup=true"
export * from "./DepartDoctor.vue?vue&type=script&lang=ts&setup=true"

import "./DepartDoctor.vue?vue&type=style&index=0&id=e29552ae&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e29552ae"]])

export default __exports__